import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_PRD4010_R01 } from "./Content_PRD4010_R01";
import { SearchSection_PRD4010_R01 } from "./SearchSection_PRD4010_R01";
import { LineCard_PRD4010_R01 } from "./LineCard_PRD4010_R01";

export const Container_PRD4010_R01 = () => {
    const { setMessage } = useUiuxStore();
    const { fetchData, handleInitClick, renderedCards } = Content_PRD4010_R01({
        setMessage,
    });

    return (
        <div className="content-container flex flex-col h-full min-h-0">
            <Actionbar
                onFetchClick={() => {
                    void fetchData(false);
                }}
                onSaveClick={undefined}
                onDeleteClick={() => {}}
                onInitClick={handleInitClick}
                onPrintClick={() => {}}
            />

            <SearchSection_PRD4010_R01 />

            <div className="flex-1 min-h-0 overflow-auto">
                <div className="flex flex-wrap gap-4 p-3">
                    {renderedCards.map((card, index) => (
                        <LineCard_PRD4010_R01
                            key={`${card.workplaceCd}_${card.workplaceNm}_${index}`}
                            data={card}
                        />
                    ))}
                </div>
            </div>

            <Message />
        </div>
    );
};
